import "./BlockCompany.css";
import accountService from "/src/features/user/services/accountService";
import { useToastDispatchContext } from "/src/layouts/toast/context/toastContext";
import { useNavigate } from "react-router-dom";
import { actualizeTitle } from "/src/utils/actualizeTitle";
import storage from "/src/utils/storage";
import urlWithRoutingCompany from "/src/utils/urlWithRoutingCompany";
import userAction from "/src/features/user/actions/userAction";
import capitalizeFirstLetter from "/src/utils/capitalizeFirstLetter";
function BlockCompany({ name, logo, id }) {
    const { changeCompany } = userAction;

    const navigate = useNavigate();

    const toast = useToastDispatchContext();
    const updateCompany = async () => {
        const res = await changeCompany(id);
        if (res.error != null) {
            return;
        }
        const { user, company } = res;

        toast.success("Congrats " + user.username, "You change your are now in" + company.name);
        navigate(urlWithRoutingCompany("home"));
    };
    return (
        <div className="block-company" onClick={updateCompany}>
            <div>
                <img src={logo}></img>
            </div>
            <span>{capitalizeFirstLetter(name)}</span>
        </div>
    );
}

export default BlockCompany;
